export function validatePaste(event) {
  var regex = new RegExp(/[@#$%^&*()+=[\]{}'"\\|<>/]/);
  var key = (event.clipboardData || window.clipboardData).getData("text");
  if (regex.test(key)) {
    event.preventDefault();
    alert("Forbidden character detected! Please only use plain text!");
    return false;
  }
}

export function regexRestriction(event) {
  let key = event.key;

  let regex = new RegExp(/[@#$%^&*()+=[\]{}'"\\|<>/]/);

  if (regex.test(key)) {
    event.preventDefault();
    return false;
  }
}
